import React from 'react';
import { Form, Button } from 'react-bootstrap';

const LoginPage = () => {
    const styles = {
        container: {
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f8f9fa',
        },
        formContainer: {
            maxWidth: '450px',
            width: '100%',
            backgroundColor: '#fff',
            padding: '20px 30px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            textAlign: 'center',
        },
        logo: {
            width: '80px',
            marginBottom: '20px',
        },
        googleButton: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '20px',
            padding: '10px 20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            backgroundColor: '#fff',
            cursor: 'pointer',
        },
        googleIcon: {
            width: '20px',
            marginRight: '10px',
        },
        submitButton: {
            width: '100%',
            backgroundColor: '#0043AA',
            borderColor: '#0043AA',
        },
        footerText: {
            marginTop: '15px',
            fontSize: '14px',
        },
        link: {
            color: '#0043AA',
            textDecoration: 'none',
        },
    };

    return (
        <div style={styles.container}>
            <div style={styles.formContainer}>
                <img src = '/assets/logoWhite.png' alt="Logo" style={styles.logo} />
                <h3>Login to your Account</h3>
                <p>See what is going on with your business</p>

                <div style={styles.googleButton}>
                    <img src='/assets/google.png' alt="Google Icon" style={styles.googleIcon} />
                    Continue with Google
                </div>

                <p>or Sign in with email</p>

                <Form>
                    <Form.Group controlId="formEmail" className="text-start">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" placeholder="mail@abc.com" />
                    </Form.Group>

                    <Form.Group controlId="formPassword" className="text-start mt-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" placeholder="Enter your password" />
                    </Form.Group>

                    <Form.Group controlId="formRememberMe" className="mt-3 d-flex justify-content-between align-items-center">
                        <Form.Check type="checkbox" label="Remember Me" />
                        <a href='/' style={styles.link}>Forgot Password?</a>
                    </Form.Group>

                    <Button type="submit" href='/' className="mt-3" style={styles.submitButton}>
                        Login
                    </Button>
                </Form>

                <p style={styles.footerText}>
                    Not Registered Yet? <a href="/register" style={styles.link}>Create an account</a>
                </p>
            </div>
        </div>
    );
};

export default LoginPage;